import React from 'react';
import useLang from '../../i18n/useLang';
import { Reveal, WordsReveal } from '../site/motion';

// "AI multiplies whoever uses it": a developer with AI against a process architect with AI, then Yuval in his own words.
export default function WhoBuilds() {
  const { t } = useLang();
  const w = (k, o) => t(`home.who.${k}`, o);
  const rows = w('rows', { returnObjects: true });

  return (
    <section className="bg-fog-50 py-24 sm:py-32">
      <div className="wrap">
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-20">
          <div>
            <h2 className="heading max-w-[16ch] text-[2.25rem] text-ink sm:text-5xl">
              <WordsReveal text={w('title')} />
            </h2>
            <Reveal as="p" delay={120} className="lead mt-6 max-w-[52ch]">
              {w('lead')}
            </Reveal>
          </div>

          <Reveal variant="scale" delay={120}>
            <table className="w-full table-fixed border-separate border-spacing-0 overflow-hidden rounded-4xl bg-white text-[1rem] shadow-card ring-1 ring-fog-200">
              <caption className="sr-only">{w('caption')}</caption>
              <thead>
                <tr>
                  <th scope="col" className="px-5 py-4 text-start text-[0.95rem] font-medium text-ink-500 sm:px-6">
                    {w('cols.first')}
                  </th>
                  <th scope="col" className="bg-mint-50 px-5 py-4 text-start text-[0.95rem] font-semibold text-grovv-800 sm:px-6">
                    {w('cols.architect')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(Array.isArray(rows) ? rows : []).map((r) => (
                  <tr key={r.first}>
                    <td className="border-t border-fog-200 px-5 py-4 align-top leading-snug text-ink-500 sm:px-6">{r.first}</td>
                    <td className="border-t border-mint-100 bg-mint-50 px-5 py-4 align-top font-medium leading-snug text-ink sm:px-6">{r.architect}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Reveal>
        </div>

        <Reveal as="figure" className="mt-16 rounded-4xl bg-white p-8 ring-1 ring-fog-200 sm:p-12">
          <p className="max-w-[72ch] text-[1.15rem] leading-[1.8] text-ink-600">{w('bio')}</p>
          <figcaption className="mt-8 flex flex-wrap items-baseline gap-x-3 gap-y-1 border-t border-fog-200 pt-6">
            <span className="text-lg font-semibold text-ink">{w('signName')}</span>
            <span className="text-ink-500">{w('signRole')}</span>
          </figcaption>
        </Reveal>
      </div>
    </section>
  );
}
